import type { Cart } from '@/js/types/cart.ts';
import { makeLocalizedStoreApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function getCart() {
  return makeRequest<Cart>({
    url: makeLocalizedStoreApiRoute('cart'),
  });
}

export async function updateCartItemQuantity(id: number, quantity: number) {
  return makeRequest<Cart>({
    method: 'PUT',
    url: makeLocalizedStoreApiRoute(`cart/item/${id}/update-quantity`),
    data: {
      quantity,
    },
  });
}

export async function addCartItem(productId: number, quantity: number) {
  return makeRequest<Cart>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('cart/item'),
    data: {
      productId,
      quantity,
    },
  });
}
